module.exports = __webpack_public_path__ + "img/logout.ad3cb2d9.svg";